// Public: Keep in sync with ImageUploader::EXTENSIONS.
export default new Set([
  'jpg',
  'jpeg',
  'gif',
  'png',
])
